import {Typography} from '~library/atoms/Typography';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {CheckmarkCircleIcon} from '~library/svg/CheckmarkCircleIcon';
import {sanitizeString} from '~library/utils/sanitize_html';

import {feedbackSuccess} from '~libSass/base/_exports.sass';
import './Header.sass';

export const Header = ({title, subtitle, description}) => {
  const isLargishAndUp = useIsLargishAndUp();
  return (
    <div className="signup__header">
      <CheckmarkCircleIcon
        ratio={0.5}
        color={feedbackSuccess}
        className="signup__header__checkmark"
      />
      <div className="signup__header__info">
        <Typography variant={isLargishAndUp ? 'header5' : 'paragraph1'} semibold>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="paragraph3" className="signup__header__subtitle">
            {subtitle}
          </Typography>
        )}
        {description && (
          <Typography
            variant={isLargishAndUp ? 'paragraph3' : 'paragraph4'}
            color="shadow"
            className="signup-sheet__rendered-rich-text"
          >
            {sanitizeString(description)}
          </Typography>
        )}
      </div>
    </div>
  );
};
